import { render, staticRenderFns } from "./T1HotelBreadcrumbs.vue?vue&type=template&id=20832d60&scoped=true&"
import script from "./T1HotelBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./T1HotelBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./T1HotelBreadcrumbs.vue?vue&type=style&index=0&id=20832d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20832d60",
  null
  
)

export default component.exports